export const NURSE_LIST_COLUMN_WIDTHS = {
  handle: 48,
  name: 116,
  preceptor: 30,
  grade: 80,
  role: 40,
  level: 60,
  experience: 40,
} as const;

function px(value: number): `${number}px` {
  return `${value}px`;
}

/** 헤더·행 간격 일치용 (프리셉터/직군 on·off 동일 적용) */
export const NURSE_LIST_COLUMNS = {
  handle: px(NURSE_LIST_COLUMN_WIDTHS.handle),
  name: px(NURSE_LIST_COLUMN_WIDTHS.name),
  preceptor: px(NURSE_LIST_COLUMN_WIDTHS.preceptor),
  // age: "50px",
  grade: px(NURSE_LIST_COLUMN_WIDTHS.grade),
  role: px(NURSE_LIST_COLUMN_WIDTHS.role),
  level: px(NURSE_LIST_COLUMN_WIDTHS.level),
  experience: px(NURSE_LIST_COLUMN_WIDTHS.experience),
} as const;
